import { MysqlService } from './../../services/mysql.service';
import { UserService } from './../../services/user.service';
import { Component, OnInit, Directive  } from '@angular/core';
import { Location, PopStateEvent } from '@angular/common';
import { filter } from 'rxjs/operators';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';


import PerfectScrollbar from 'perfect-scrollbar';

@Component({
    selector: 'app-admin-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss'],
    standalone: false
})
export class AdminLayoutComponent implements OnInit {
    private _router: Subscription;
    private lastPoppedUrl: string;
    private yScrollStack: number[] = [];

    user;

    constructor(public location: Location, private router: Router, private userService: UserService, private db: MysqlService) { }

    ngOnInit() {

        this.userService.onUserState()
            .subscribe((user: any) => {

                this.db.get_current_user_profile().then(res => {

                    console.log(res)

                    ///// clear auth if token invalid
                    if (localStorage.getItem('authority'))
                        if (res.status == 'ERROR' && res.error.errorInfo[2] == "Authentication failed!") {
                            localStorage.clear()
                            window.location.reload()
                            return
                        }


                    this.user = res[0]

                    console.log('auth obs')
                });

            });

        const isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;

        if (isWindows && !document.getElementsByTagName('body')[0].classList.contains('sidebar-mini')) {
            // if we are on windows OS we activate the perfectScrollbar function

            document.getElementsByTagName('body')[0].classList.add('perfect-scrollbar-on');
        } else {
            document.getElementsByTagName('body')[0].classList.remove('perfect-scrollbar-off');
        }
        const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
        const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');

        this.location.subscribe((ev: PopStateEvent) => {
            this.lastPoppedUrl = ev.url;
        });
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationStart) {
                if (event.url != this.lastPoppedUrl)
                    this.yScrollStack.push(window.scrollY);
            } else if (event instanceof NavigationEnd) {
                if (event.url == this.lastPoppedUrl) {
                    this.lastPoppedUrl = undefined;
                    window.scrollTo(0, this.yScrollStack.pop());
                } else
                    window.scrollTo(0, 0);
            }
        });


        this._router = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {

            try {

                elemMainPanel.scrollTop = 0;
                elemSidebar.scrollTop = 0;
            } catch (error) {

            }

        });
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            try {

                let ps = new PerfectScrollbar(elemMainPanel);
                ps = new PerfectScrollbar(elemSidebar);
            } catch (error) {

            }
        }
    }
    ngAfterViewInit() {
        this.runOnRouteChange();
    }
    isMaps(path) {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        titlee = titlee.slice(1);
        if (path == titlee) {
            return false;
        }
        else {
            return true;
        }
    }
    runOnRouteChange(): void {
        try {
            if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
                const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
                const ps = new PerfectScrollbar(elemMainPanel);
                ps.update();
            }
        } catch (error) {

        }

    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }

}
